module.exports = {
    TRACKING: {
        mazda: {
            'cx-3': {
                'suv': {
                    link: 'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885902&PluID=0&ord=[timestamp]'
                }
            },
            'cx-5': {
                'suv': {
                    link: 'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885886&PluID=0&ord=[timestamp]'
                }
            },
            'cx-9': {
                'suv': {
                    link: 'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885967&PluID=0&ord=[timestamp]'
                }
            },
            '3': {
                'hatchback': {
                    link: 'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885934&PluID=0&ord=[timestamp]'
                },
                'sedan': {
                    link: 'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885951&PluID=0&ord=[timestamp]'
                }
            },
            'mx-5-miata': {
                'convertible': {
                    link: 'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19886009&PluID=0&ord=[timestamp]'
                }
            },
            'mx-5-miata-rf': {
                'convertible': {
                    link: 'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19886026&PluID=0&ord=[timestamp]'
                }
            },
            '5': {
                'minivan': {
                    link: 'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885918&PluID=0&ord=[timestamp]'
                }
            },
            '6': {
                'sedan': {
                    link: 'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885983&PluID=0&ord=[timestamp]'
                }
            }
        },
        lexus: {
            'ct-200h': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N3753.Edmunds/B10529353.140450567;dc_trk_aid=313775970;' +
                'dc_trk_cid=76333520;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'es-300h': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N3753.Edmunds/B10529353.140449579;dc_trk_aid=313777287;' +
                'dc_trk_cid=76333520;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            } ,
            'es-350': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N3753.Edmunds/B10529353.140450558;dc_trk_aid=313777079;' +
                'dc_trk_cid=76333520;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'gs-200': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N3753.Edmunds/B10529353.140449532;dc_trk_aid=313775468;' +
                'dc_trk_cid=76333520;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'gs-350':{
                link: 'https://ad.doubleclick.net/ddm/trackclk/N3753.Edmunds/B10529353.140448536;dc_trk_aid=313775468;' +
                'dc_trk_cid=76333520;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'gs-450h': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N3753.Edmunds/B10529353.140449551;dc_trk_aid=313777270;' +
                'dc_trk_cid=76333520;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'gx-460': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N3753.Edmunds/B10529353.140450564;dc_trk_aid=313778186;' +
                'dc_trk_cid=76333520;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'is-200t': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N3753.Edmunds/B10529353.140449597;dc_trk_aid=313774596;' +
                'dc_trk_cid=76333520;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'is-250-c': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N3753.Edmunds/B10529353.140450511;dc_trk_aid=313774596;' +
                'dc_trk_cid=76333520;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'is-250': {
                link:'https://ad.doubleclick.net/ddm/trackclk/N3753.Edmunds/B10529353.140448544;dc_trk_aid=313774596;' +
                'dc_trk_cid=76333520;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'is-350-c': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N3753.Edmunds/B10529353.140450521;dc_trk_aid=313774596;' +
                'dc_trk_cid=76333520;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'is-350': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N3753.Edmunds/B10529353.140449561;dc_trk_aid=313774596;' +
                'dc_trk_cid=76333520;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'is-300': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N3753.Edmunds/B10529353.140449566;dc_trk_aid=313774596;' +
                'dc_trk_cid=76333520;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'lc-500': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N3753.Edmunds/B10529353.140450506;dc_trk_aid=313776540;' +
                'dc_trk_cid=76333520;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'ls-460': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N3753.Edmunds/B10529353.140449593;dc_trk_aid=313776245;' +
                'dc_trk_cid=76333520;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'ls-600h-l': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N3753.Edmunds/B10529353.140448547;dc_trk_aid=313776245;' +
                'dc_trk_cid=76333520;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'lx-570': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N3753.Edmunds/B10529353.140448586;dc_trk_aid=313776055;' +
                'dc_trk_cid=76333520;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'nx-200t': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N3753.Edmunds/B10529353.140449548;dc_trk_aid=313778104;' +
                'dc_trk_cid=76333520;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'nx-300h': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N3753.Edmunds/B10529353.140450560;dc_trk_aid=313777228;' +
                'dc_trk_cid=76333520;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'rc-200t': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N3753.Edmunds/B10529353.140449569;dc_trk_aid=313776637;' +
                'dc_trk_cid=76333520;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'rc-300': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N3753.Edmunds/B10529353.140449510;dc_trk_aid=313776637;' +
                'dc_trk_cid=76333520;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'rc-350': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N3753.Edmunds/B10529353.140448563;dc_trk_aid=313776637;' +
                'dc_trk_cid=76333520;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'rx-350': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N3753.Edmunds/B10529353.140450539;dc_trk_aid=313775667;' +
                'dc_trk_cid=76333520;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'rx-450h': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N3753.Edmunds/B10529353.140448566;dc_trk_aid=313775494;' +
                'dc_trk_cid=76333520;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            }
        },
        cadillac: {
            'cts': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N8334.2990.EDMUNDS.COMINC1/B10720206.142989230;dc_trk_aid=315098176;' +
                'dc_trk_cid=75702429;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'escalade': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N8334.2990.EDMUNDS.COMINC1/B10720206.142996915;dc_trk_aid=315098175;' +
                'dc_trk_cid=75704170;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'xt5': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N8334.2990.EDMUNDS.COMINC1/B10720206.142989228;dc_trk_aid=315098174;' +
                'dc_trk_cid=75704153;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'ats-coupe': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N8334.2990.EDMUNDS.COMINC1/B10720206.142996914;dc_trk_aid=315098182;' +
                'dc_trk_cid=75704276;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'ats': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N8334.2990.EDMUNDS.COMINC1/B10720206.142988345;dc_trk_aid=315098181;' +
                'dc_trk_cid=76151917;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'ct6': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N8334.2990.EDMUNDS.COMINC1/B10720206.142999520;dc_trk_aid=315098177;' +
                'dc_trk_cid=75704718;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'cts-v': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N8334.2990.EDMUNDS.COMINC1/B10720206.142999519;dc_trk_aid=315098178;' +
                'dc_trk_cid=75702415;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'escalade-esv': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N8334.2990.EDMUNDS.COMINC1/B10720206.142989536;dc_trk_aid=315098175;' +
                'dc_trk_cid=75704170;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'ats-v': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N8334.2990.EDMUNDS.COMINC1/B10720206.142989537;dc_trk_aid=315098179;' +
                'dc_trk_cid=75698379;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'xts': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N8334.2990.EDMUNDS.COMINC1/B10720206.142992617;dc_trk_aid=315098180;' +
                'dc_trk_cid=75699158;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            }
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/creative/core-page/deep-link/deep-link-constants.js
// module id = 128
// module chunks = 0 1 23